
export interface CustomerResponseState{
    customerList: CustomerResponse[]
}

export interface CustomerDetailResponseState{
    customerDetailItem: CustomerDetail
}

export class CustomerDetailClass{
      
    AD_UNVAN2 :string ="";
    AUTH_PERSON_ID :string ="";
    BINA_ADI :string ="";
    BINA_NO :string ="";
    BLOCKING_DESC :string ="";
    BLOCKING_REASON_CD :string ="";
    CADDE :string ="";
    CINSIYET :string ="";
    CUSTOMER :string ="";
    CUST_NO :string ="";
    EMAIL_ADDRESS :string ="";
    ILETISIM_YETKILISI :string ="";
    IZIN_EPOSTA :string ="";
    IZIN_SMS :string ="";
    KAYIT_KANALI :string ="";
    KAYIT_MAGAZA :string ="";
    KAYIT_TARIHI :string ="";
    KISAAD_TICARI :string ="";
    LEVEL1 :string ="";
    LEVEL4 :string ="";
    LEVEL4_DESC :string ="";
    LEVEL_1_DESC :string ="";
    MAHALLE :string ="";
    MOBILE_PHONE_NO :string ="";
    PHONE_NO :string ="";
    SEMT :string ="";
    SIRKET_POZISYON :string ="";
    SIRKET_POZISYON_CD :string ="";
    SOKAK :string ="";
    SON_DEGISIKLIK_TARIHI :string ="";
    SON_F_SATINALMA :string ="";
    SON_NF_SATINALMA :string ="";
    SOYAD_TABELA :string ="";
    SOYAD_TABELA2 :string ="";
    SOYAD_UNVAN :string ="";
    STATUS :string ="";
    STATUS_DESC :string ="";
    STORE_KEY :string ="";
    S_LISANS :string ="";
    TERCIH_MAGAZA :string ="";
    T_LISANS: string=""
    VERGI_DAIRESI :string ="";
    VERGI_NO :string ="";
    YASAL_YETKILI :string ="";
    DateWarning:boolean =false;
    SmsIzni:boolean =false;
    EpostaIzni:boolean =false;
    AdresIzni:boolean =false;
    KayitTarihiStr:string =""; 
    KAPI_NO:string ="";
    Ilce_Id:string="";
    Mahalle_Id:string="";
    AddressTypeCd:string="R";
    CustomerGuid:string="";
    Kurumsal:boolean=false;
    YasalYetkili:boolean=false;
    PrmCustomerGuid:string ="";
    IsHaveMUGE:boolean = false;
}

export interface SignModel{
    signName:string
    statu:boolean
}

export interface CustomerDetail {
    AD_UNVAN2 :string
    AUTH_PERSON_ID :string 
    BINA_ADI :string 
    BINA_NO :string
    BLOCKING_DESC :string
    BLOCKING_REASON_CD :string
    CADDE :string
    CINSIYET :string
    CUSTOMER :string
    CUST_NO :string
    EMAIL_ADDRESS :string
    ILETISIM_YETKILISI :string
    IZIN_EPOSTA :string
    IZIN_SMS :string
    KAYIT_KANALI :string
    KAYIT_MAGAZA :string
    KAYIT_TARIHI :string
    KISAAD_TICARI :string
    LEVEL1 :string
    LEVEL4 :string
    LEVEL4_DESC :string
    LEVEL_1_DESC :string
    MAHALLE :string
    MOBILE_PHONE_NO :string
    PHONE_NO :string
    SEMT :string
    SIRKET_POZISYON :string
    SIRKET_POZISYON_CD :string
    SOKAK :string
    SON_DEGISIKLIK_TARIHI :string
    SON_F_SATINALMA :string
    SON_NF_SATINALMA :string
    SOYAD_TABELA :string
    SOYAD_TABELA2 :string
    SOYAD_UNVAN :string
    STATUS :string
    STATUS_DESC :string
    STORE_KEY :string
    S_LISANS :string
    TERCIH_MAGAZA :string
    T_LISANS: string
    VERGI_DAIRESI :string
    VERGI_NO :string
    YASAL_YETKILI :string
    DateWarning:boolean
    SmsIzni:boolean
    EpostaIzni:boolean
    AdresIzni:boolean
    KayitTarihiStr:string
    KAPI_NO:string
    Ilce_Id:string
    Mahalle_Id:string
    AddressTypeCd:string
    CustomerGuid:string
    Kurumsal:boolean
    YasalYetkili:boolean
    PrmCustomerGuid:string
    IsHaveMUGE:boolean
}
  


export interface CustomerResponse{
    id :number
    BrandName :string
    CardNumber :number
    CustomerNumber :number
    Email :string
    MobilePhoneNumber :number
    PhoneNumber :number
    ShortName :string
    TaxNumber:number
    StoreKey:number
    ValidationDate:string
    Type:string
    AUTH_PERSON_ID:string
    IsActive:boolean
    IsBloked:boolean
    BlockedCode:string
}

export interface Customer {
    MobilePhoneNumber : number
    CustomerNumber : number
    TaxNumber:number
    CardNumber :number
    Email :string
    BrandName :string
    PhoneNumber : number
    ShortName : string
}
  